module.exports = __webpack_public_path__ + "img/financeiroFill.5e2abbf3.svg";